<py-puff-collection-content-tags
  *ngIf="componentData?.searchEnabled === 'true'"
  [contentTagUids]="componentData?.contentTags?.split(' ')"
  (update)="getTaggedPuffs($event)"
></py-puff-collection-content-tags>
<div *ngIf="taggedPuffs$ | async as taggedPuffs">
  <div
    *ngIf="componentData"
    class="puff-collection-holder row no-gutters component-holder"
    [ngClass]="componentData.styleClasses || 'puff-collection-default-list'"
    [class.hide-content-tags]="componentData?.searchEnabled !== 'true' || componentData?.tagsOnThumbnails !== 'true'"
  >
    <ng-container *ngFor="let puffUid of puffUids">
      <ng-container
        [styleClassesOverride]="componentData.styleClasses"
        [cxComponentWrapper]="{
          flexType: 'PuffComponent',
          typeCode: 'PuffComponent',
          uid: puffUid
        }"
      ></ng-container>
    </ng-container>
  </div>
  <py-puff-collection-pagination
    [puffComponentsArray]="taggedPuffs"
    [maxShown]="componentData.pageSize || 0"
    [showPagination]="componentData?.pagingEnabled == 'true'"
    (setPuffUids)="onSetPuffUids($event)"
  ></py-puff-collection-pagination>
</div>
